<template>
  <div class="publish-act">
    <div class="head">
      <div class="title-wrap">
        <div class="title-name">发布活动</div>
        <div class="title-desc">你可把活动发布至「联机大厅-活动」中，让更多的玩家参与你的活动，准入门槛可见<a class="title-link" :href="actRuleLink" target="_blank">《活动申请准则》</a></div>
      </div>
      <div class="add">
        <el-button type="primary" plain class="add-btn" @click="add">申请发布活动</el-button>
      </div>
    </div>
    <el-table class="table" :data="list" stripe border v-loading="loading">
      <el-table-column prop="pid" label="动态ID" width="180px" />
      <el-table-column prop="name" label="活动名称" />
      <el-table-column prop="belong_map" label="所属地图" />
      <el-table-column prop="atype" label="活动类型" :formatter="actTypeFormater" />
      <el-table-column label="展示时间" width="270px" :formatter="timeFormater" />
      <el-table-column prop="state" label="状态">
        <template slot-scope="scope">
          <div>
            <el-tooltip v-if="scope.row.state === 2" effect="dark" :content="scope.row.state_desc" placement="top-start">
              <span>{{ stateFormater(scope.row) }}<i class="el-icon-question"></i></span>
            </el-tooltip>
            <el-tooltip v-else-if="stateFormater(scope.row) === '展示中'" effect="dark" placement="top-start">
              <div slot="content">
                <p>若未发现你的活动展示，其不可见原因如下：</p>
                <p>1.你的动态因删除、被举报下架等原因失效，请等动态生效后刷新查看</p>
                <p>2.你调整了可见范围，请把可见范围调整为「所有人可见」后再查看</p>
              </div>
              <span>{{ stateFormater(scope.row) }}<i class="el-icon-question"></i></span>
            </el-tooltip>
            <span v-else>{{ stateFormater(scope.row) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pid" label="操作">
        <template slot-scope="scope">
          <!-- 已过期 -->
          <div v-if="scope.row.state === 3">
            <el-button class="btn" type="text" @click="editState(scope.row, 'DELETED')">删除</el-button>
          </div>
          <!-- 审核通过 -->
          <div v-else-if="scope.row.state === 4"> 
            <el-button class="btn" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button class="btn" type="text" @click="editState(scope.row, 'UNPUBLISHED')">下架</el-button>
          </div>
          <!-- 审核中 -->
          <div v-else-if="scope.row.state === 1"> 
            <el-button class="btn" type="text" @click="editState(scope.row, 'CANCELED')">取消审核</el-button>
          </div>
          <!-- 未通过 -->
          <div v-else-if="scope.row.state === 2"> 
            <el-button class="btn" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button class="btn" type="text" @click="editState(scope.row, 'DELETED')">删除</el-button>
          </div>
          <!-- 取消审核 -->
          <div v-else-if="scope.row.state === 5"> 
            <el-button class="btn" type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button class="btn" type="text" @click="editState(scope.row, 'DELETED')">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination
      background
      @current-change="CurrentChange"
      :current-page="pagination.page"
      :page-size="pagination.page_size"
      layout="prev, pager, next,jumper"
      :total="pagination.total"
      hide-on-single-page
    >
    </el-pagination>
  </div>
</template>

<script>
import { GetPidList, EditActState } from '@/api/publishAct.js';
import { mapState } from 'vuex';
import { dateFormat } from '@/utils';

const ACT_TYPE_OPTIONS = [
  { label: '游戏内福利', value: 1 },
  { label: '抽奖', value: 2 },
  { label: '其他活动', value: 3 },
];

const STATE_OPTIONS = [
  { label: '审核中', value: 1 },
  { label: '未通过', value: 2 },
  { label: '已过期', value: 3 },
  { label: '审核通过', value: 4 },
  { label: '取消审核', value: 5 },
  { label: '取消展示', value: 6 },
];

const ACT_STATUS = {
  PENDING: 1, // 等待审核
  REJECTED: 2, // 审核被拒绝
  EXPIRED: 3, // 过期
  APPROVED: 4, // 审核通过
  CANCELED: 5, // 取消审核
  UNPUBLISHED: 6, // 下架
  DELETED: 7, // 主动删除
};

export default {
  data() {
    return {
      actRuleLink: 'https://dev-wiki.mini1.cn/article/673ff10dd07d9b268819de95',
      loading: false,
      list: [],
      pagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      editFormDialog: {
        data: null,
        type: '',
      },
    };
  },
  computed: {
    ...mapState(['developerInfo']),
  },
  mounted() {
    this.getList();
  },
  methods: {
    async add() {
      this.$router.push({ name: 'PublishActDetail', query: { type: 'add' } });
    },
    edit(row) {
      this.$router.push({ name: 'PublishActDetail', query: { type: 'edit', id: row.id } });
    },
    async getList() {
      try {
        const params = {
          ...this.pagination,
        };
        this.loading = true;
        const res = await GetPidList(params);
        this.loading = false;
        if (res.code !== 0) {
          return;
        }
        this.list = res.data.list;
        this.pagination.total = res.data.count;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    CurrentChange(currPage) {
      this.pagination.page = currPage;
      this.getList();
    },
    timeFormater(row) {
      const startTime = row.card_start_time * 1000;
      const endTime = row.card_end_time * 1000;
      return dateFormat(startTime, 'YYYY-MM-DD HH:mm') + ' 至 ' + dateFormat(endTime, 'YYYY-MM-DD HH:mm');
    },
    actTypeFormater(row) {
      return ACT_TYPE_OPTIONS.find(item => row.atype === item.value)?.label;
    },
    stateFormater(row) {
      const option = STATE_OPTIONS.find(item => row.state === item.value);
      const now = Math.floor(new Date().getTime() / 1000);
      if (option?.value === 4) {
        if (now < row.card_start_time) {
          return '审核通过待展示';
        } else {
          return '展示中';
        }
      } else {
        return option?.label;
      }
    },
    async editState(row, targetStateStr) {
      if (targetStateStr === 'DELETED') {
        await this.$confirm('确定删除改活动？', '提示', { type: 'warning', });
      }
      if (targetStateStr === 'UNPUBLISHED') {
        await this.$confirm('确定下架改活动？', '提示', { type: 'warning', });
      }
      if (targetStateStr === 'CANCELED') {
        await this.$confirm('确定取消审核？', '提示', { type: 'warning', });
      }
      const targetState = ACT_STATUS[targetStateStr];
      if (!targetState) {
        console.error('targetState不存在', targetStateStr);
        return;
      }
      try {
        const params = {
          id: row.id,
          state: targetState,
          state_desc: targetStateStr,
        };
        this.loading = true;
        const res = await EditActState(params);
        this.loading = false;
        this.$message.success('操作成功');
        this.getList();
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.publish-act {
  .head {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
    .title-wrap {
      .title-desc {
        font-size: 14px;
        color: #8c8c8c;
        margin-top: 8px;
        .title-link {
          color: #2b6ddf;
          text-decoration: none;
        }
      }
    }
  }
  .btn {
    color: #50a3f1;
  }
}
</style>
